<nav class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
    <!-- <div class="navbar-brand-wrapper d-flex align-items-center menu-top-corner">
        <a class="navbar-brand brand-logo">
            <img src="assets/images/full-logo1.png" *ngIf="Role!='Printer'" alt="logo" class="logo-dark" />
        </a>
        <a class="navbar-brand brand-logo-mini" ><img src="assets/images/logo.jpg" alt="logo" /></a>
    </div> -->


            <div class="navbar-menu-wrapper d-flex align-items-center flex-grow-1">
                <div class="nav-heading-head">
                    <!-- <h5 class="mb-0 font-weight-medium d-none d-lg-flex">
                        <i class="fas fa-house"(click)="redirectToHome()"title="Back To Home"></i>&nbsp;&nbsp;
                        Welcome to {{Role}} dashboard!
                    </h5> -->
                  
                
            
            
            

            <!-- <h5 class="mb-0 font-weight-medium d-none d-lg-flex sardar-class">Jai Baba Balak Nath
                
            </h5> -->
            <!-- <div class="navbar-brand-wrapper d-flex align-items-center menu-top-corner"> -->
                <div class="navbar-brand-wrapper d-flex justify-content-center align-items-center menu-top-corner">
                <a class="navbar-brand brand-logo"routerLink='/v/dashboard/home'>
                    <img src="assets/images/full-logo1.png" *ngIf="Role!='Printer'" alt="logo" class="logo-dark" />
                </a>
                <!-- <a class="navbar-brand brand-logo-mini" ><img src="assets/images/logo.jpg" alt="logo" /></a> -->
            </div>
        </div>
        <ul class="navbar-nav navbar-nav-right ml-auto">
            <li class="nav-item dropdown  d-xl-inline-flex user-dropdown">
                <a class="nav-link dropdown-toggle" id="UserDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
                    <img class="img-xs rounded-circle ml-2" src="assets/images/profile.png" alt="Profile image"> <span class="font-weight-normal"> {{loginusername}} </span></a>
                <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="UserDropdown">
                    <div class="dropdown-header text-center">
                        <img class="img-md rounded-circle" src="assets/images/profile.png" alt="Profile image" style="width: 40px;">
                        <p class="mb-1 mt-3">{{loginusername}} </p>
                    </div>
                    <!-- <a [routerLink]="['/v/profile']" class="dropdown-item"><i class="dropdown-item-icon icon-user text-primary"></i> My Profile </a> -->

                    <a [routerLink]="['/v/changepassword']" class="dropdown-item"><i
              class="dropdown-item-icon icon-user text-primary"></i> Change Password </a>

                    <a (click)="logout()" class="dropdown-item"><i class="dropdown-item-icon icon-power text-primary"></i>Sign
            Out</a>
                </div>
            </li>
        </ul>
    </div>
</nav>